export * from '@iotize/tap/service/core';
export * from '@iotize/tap/service/impl/ble';
export * from '@iotize/tap/service/impl/bundle';
export * from '@iotize/tap/service/impl/cloud';
export * from '@iotize/tap/service/impl/data-log';
export * from '@iotize/tap/service/impl/device';
export * from '@iotize/tap/service/impl/firmware';
export * from '@iotize/tap/service/impl/group';
export * from '@iotize/tap/service/impl/interface';
export * from '@iotize/tap/service/impl/jvm';
export * from '@iotize/tap/service/impl/lora';
export * from '@iotize/tap/service/impl/mqtt';
export * from '@iotize/tap/service/impl/scram';
export * from '@iotize/tap/service/impl/single-packet';
export * from '@iotize/tap/service/impl/target';
export * from '@iotize/tap/service/impl/tapnpass';
export * from '@iotize/tap/service/impl/variable';
export * from '@iotize/tap/service/impl/wifi';
export * from '@iotize/tap/service/impl/time';
export * from '@iotize/tap/service/impl/ethernet';
export * from '@iotize/tap/service/impl/slave-server';
export * from '@iotize/tap/service/impl/lte';

import {
  _TAP_SERVICE_EXTENSION_BLE_,
  BleResourceKeyMapping,
  BleResourceMetaData,
} from '@iotize/tap/service/impl/ble';
import {
  _TAP_SERVICE_EXTENSION_BUNDLE_,
  BundleResourceKeyMapping,
  BundleResourceMetaData,
} from '@iotize/tap/service/impl/bundle';
import {
  _TAP_SERVICE_EXTENSION_CLOUD_,
  CloudResourceKeyMapping,
  CloudResourceMetaData,
} from '@iotize/tap/service/impl/cloud';
import {
  _TAP_SERVICE_EXTENSION_DATALOG_,
  DataLogResourceKeyMapping,
  DataLogResourceMetaData,
} from '@iotize/tap/service/impl/data-log';
import {
  _TAP_SERVICE_EXTENSION_DEVICE_,
  DeviceResourceKeyMapping,
  DeviceResourceMetaData,
} from '@iotize/tap/service/impl/device';
import {
  _TAP_SERVICE_EXTENSION_FIRMWARE_,
  FirmwareResourceKeyMapping,
  FirmwareResourceMetaData,
} from '@iotize/tap/service/impl/firmware';
import {
  _TAP_SERVICE_EXTENSION_GROUP_,
  GroupResourceKeyMapping,
  GroupResourceMetaData,
} from '@iotize/tap/service/impl/group';
import {
  _TAP_SERVICE_EXTENSION_INTERFACE_,
  InterfaceResourceKeyMapping,
  InterfaceResourceMetaData,
} from '@iotize/tap/service/impl/interface';
import {
  _TAP_SERVICE_EXTENSION_JVM_,
  JvmResourceKeyMapping,
  JvmResourceMetaData,
} from '@iotize/tap/service/impl/jvm';
import {
  _TAP_SERVICE_EXTENSION_LORA_,
  LoraResourceKeyMapping,
  LoraResourceMetaData,
} from '@iotize/tap/service/impl/lora';
import {
  _TAP_SERVICE_EXTENSION_MQTT_,
  MqttResourceKeyMapping,
  MqttResourceMetaData,
} from '@iotize/tap/service/impl/mqtt';
import {
  _TAP_SERVICE_EXTENSION_SCRAM_,
  ScramResourceKeyMapping,
  ScramResourceMetaData,
} from '@iotize/tap/service/impl/scram';
import {
  _TAP_SERVICE_EXTENSION_SINGLEPACKET_,
  SinglePacketResourceKeyMapping,
  SinglePacketResourceMetaData,
} from '@iotize/tap/service/impl/single-packet';
import {
  _TAP_SERVICE_EXTENSION_TARGET_,
  TargetResourceKeyMapping,
  TargetResourceMetaData,
} from '@iotize/tap/service/impl/target';
import {
  _TAP_SERVICE_EXTENSION_TAPNPASS_,
  TapnpassResourceKeyMapping,
  TapnpassResourceMetaData,
} from '@iotize/tap/service/impl/tapnpass';
import {
  _TAP_SERVICE_EXTENSION_VARIABLE_,
  VariableResourceKeyMapping,
  VariableResourceMetaData,
} from '@iotize/tap/service/impl/variable';
import {
  _TAP_SERVICE_EXTENSION_WIFI_,
  WifiResourceKeyMapping,
  WifiResourceMetaData,
} from '@iotize/tap/service/impl/wifi';
import {
  _TAP_SERVICE_EXTENSION_TIME_,
  TimeResourceKeyMapping,
  TimeResourceMetaData,
} from '@iotize/tap/service/impl/time';
import {
  _TAP_SERVICE_EXTENSION_ETHERNET_,
  EthernetResourceKeyMapping,
  EthernetResourceMetaData,
} from '@iotize/tap/service/impl/ethernet';
import {
  _TAP_SERVICE_EXTENSION_SLAVESERVER_,
  SlaveServerResourceKeyMapping,
  SlaveServerResourceMetaData,
} from '@iotize/tap/service/impl/slave-server';

export const TapResourceMetaData = {
  ...BleResourceMetaData,
  ...BundleResourceMetaData,
  ...CloudResourceMetaData,
  ...DataLogResourceMetaData,
  ...DeviceResourceMetaData,
  ...FirmwareResourceMetaData,
  ...GroupResourceMetaData,
  ...InterfaceResourceMetaData,
  ...JvmResourceMetaData,
  ...LoraResourceMetaData,
  ...MqttResourceMetaData,
  ...ScramResourceMetaData,
  ...SinglePacketResourceMetaData,
  ...TargetResourceMetaData,
  ...TapnpassResourceMetaData,
  ...VariableResourceMetaData,
  ...WifiResourceMetaData,
  ...TimeResourceMetaData,
  ...EthernetResourceMetaData,
  ...SlaveServerResourceMetaData,
};

export interface TapResourceKeyMapping
  extends BleResourceKeyMapping,
    BundleResourceKeyMapping,
    CloudResourceKeyMapping,
    DataLogResourceKeyMapping,
    DeviceResourceKeyMapping,
    FirmwareResourceKeyMapping,
    GroupResourceKeyMapping,
    InterfaceResourceKeyMapping,
    JvmResourceKeyMapping,
    LoraResourceKeyMapping,
    MqttResourceKeyMapping,
    ScramResourceKeyMapping,
    SinglePacketResourceKeyMapping,
    TargetResourceKeyMapping,
    TapnpassResourceKeyMapping,
    VariableResourceKeyMapping,
    WifiResourceKeyMapping,
    TimeResourceKeyMapping,
    EthernetResourceKeyMapping,
    SlaveServerResourceKeyMapping {}

// Reexport shared types
export {
  TapVersion,
  SpecialFeature,
  HostProtocol,
  AppPathType,
  VariableFormat,
  TargetProtocol,
} from '@iotize/tap';

export const _TAP_SERVICE_ALL_EXTENSIONS_ = [
  _TAP_SERVICE_EXTENSION_BLE_,
  _TAP_SERVICE_EXTENSION_BUNDLE_,
  _TAP_SERVICE_EXTENSION_CLOUD_,
  _TAP_SERVICE_EXTENSION_DATALOG_,
  _TAP_SERVICE_EXTENSION_DEVICE_,
  _TAP_SERVICE_EXTENSION_FIRMWARE_,
  _TAP_SERVICE_EXTENSION_GROUP_,
  _TAP_SERVICE_EXTENSION_INTERFACE_,
  _TAP_SERVICE_EXTENSION_JVM_,
  _TAP_SERVICE_EXTENSION_LORA_,
  _TAP_SERVICE_EXTENSION_MQTT_,
  _TAP_SERVICE_EXTENSION_SCRAM_,
  _TAP_SERVICE_EXTENSION_SINGLEPACKET_,
  _TAP_SERVICE_EXTENSION_TARGET_,
  _TAP_SERVICE_EXTENSION_TAPNPASS_,
  _TAP_SERVICE_EXTENSION_VARIABLE_,
  _TAP_SERVICE_EXTENSION_WIFI_,
  _TAP_SERVICE_EXTENSION_TIME_,
  _TAP_SERVICE_EXTENSION_ETHERNET_,
  _TAP_SERVICE_EXTENSION_SLAVESERVER_,
];
